<template>
  <v-card class="blog-card d-flex flex-column" outlined hover @click="$emit('click')" height="380">
    <!-- Thumbnail (primera imagen si hay) -->
    <v-img v-if="thumbnailUrl" :src="thumbnailUrl" height="180" class="grey lighten-3"
      gradient="to bottom, rgba(0,0,0,0), rgba(0,0,0,0.3)">
      <template v-slot:placeholder>
        <v-row class="fill-height ma-0" align="center" justify="center">
          <v-progress-circular indeterminate color="grey lighten-1"></v-progress-circular>
        </v-row>
      </template>
    </v-img>
    <v-img v-else height="100" class="grey lighten-3 d-flex align-center justify-center">
      <v-icon size="48" color="grey lighten-1">mdi-post-outline</v-icon>
    </v-img>

    <v-card-title class="text-subtitle-1 font-weight-bold pb-1" style="word-break: break-word; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;">
      {{ post.title }}
    </v-card-title>

    <v-card-subtitle class="pb-2 pt-2">
      {{ excerpt }}
    </v-card-subtitle>

    <v-card-text class="pt-0" style="flex: 1; display: flex; flex-direction: column; justify-content: flex-end;">
      <!-- Autor -->
      <div class="d-flex align-center mb-2">
        <v-icon small color="grey" class="mr-1">mdi-account</v-icon>
        <span class="caption font-weight-medium">{{ authorName }}</span>
        <v-spacer></v-spacer>
        <v-icon small color="grey" class="mr-1">mdi-calendar</v-icon>
        <span class="caption">{{ formatDate(post.created_at) }}</span>
      </div>

      <!-- Contadores -->
      <div class="d-flex align-center">
        <v-icon small color="red lighten-1" class="mr-1">mdi-heart</v-icon>
        <span class="caption mr-3">{{ post.likes_count || 0 }}</span>
        <v-icon small color="blue lighten-1" class="mr-1">mdi-comment</v-icon>
        <span class="caption">{{ post.comments_count || 0 }}</span>
        <v-spacer></v-spacer>
        <v-chip x-small color="teal lighten-4" v-if="post.pinned">
          <v-icon x-small left>mdi-pin</v-icon> Fijado
        </v-chip>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import forumService from '@/services/forumService.js';

export default {
  name: 'BlogPostCard',
  props: {
    post: { type: Object, required: true }
  },
  computed: {
    thumbnailUrl() {
      if (this.post.images && this.post.images.length) {
        return forumService.getImageUrl(this.post.id, this.post.images[0].img_url);
      }
      return null;
    },
    excerpt() {
      if (!this.post.body) return '';
      // Strip HTML y recortar a 120 chars
      const text = this.post.body.replace(/<[^>]+>/g, '');
      return text.length > 120 ? text.substring(0, 120) + '...' : text;
    },
    authorName() {
      return this.post.user ? this.post.user.name : 'Admin';
    }
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      return d.toLocaleDateString('es', { day: '2-digit', month: 'short', year: 'numeric' });
    }
  }
};
</script>

<style scoped>
.blog-card {
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}
.blog-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.15) !important;
}
</style>
